export default __webpack_public_path__ + "static/media/gallery_01.f4e336a4.jpg";